export const sqlLightTheme: monaco.editor.IStandaloneThemeData = {
  base: 'vs',
  inherit: true,
  rules: [],
  colors: {
    'editor.foreground': '#292B33',
    'editor.background': '#FFFFFF',
    'editor.selectionHighlight': '#82D7AB',

    'input.border': '#6E26EC',
    contrastBorder: '#D4D3D8',

    'editorWidget.background': '#FFFFFF',
    'editorWidget.border': '#373943',

    'editorSuggestWidget.background': '#FBF9FB',
    'editorSuggestWidget.selectedBackground': '#6120D1',
    'editorSuggestWidget.highlightForeground': '#948AFD',
    'editorSuggestWidget.border': '#EDECEF',
    'editorSuggestWidget.foreground': '#292B33',

    'list.highlightForeground': '#D2CFFD',
    'list.activeSelectionBackground': '#6120D1',
    'list.hoverBackground': '#EDECEF',
  },
};
